<div class='text-center'>

  <div class='checkmark centered'></div>
  <h3>Thanks!</h3>

  <p>
    We'll let you know when we get to your neighborhood, so you can be one of
    the first to switch to Starry's exceptional internet service.
  </p>
</div>
